
import React from 'react';
import classNames from "classnames";
import { sprintf } from 'sprintf-js';
import { Popup } from "../../../lib/onboarding-shared/popup";
import { OptionPopupMenu } from "./OptionPopupMenu";
import { PopupContext } from "./PopupContext";
import { HamburgerIcon } from "../../funcs/utils";
import { CookieWrap as Cookies } from "../../helper/cookie-wrap";
import { DEVICE_WIDTH } from "../../../lib/constants";
import { isMobile } from "react-device-detect";
import "./styles.scss";
import {config_to_url} from "../../helper/url";
import {broadcast_message} from "../../app/popup_window_factory";
import {WINDOW_EVENTS} from "../../app/window_events";
import {POPUP_TIMEOUT_MS} from "../../../lib/ui-constants";

const FONT_SIZE = "1rem";

class BannerMenu extends React.Component {

  constructor(props) {
    super(props);
    // buttons:
    // For triggering a callback
    // { label: {String}, id: {String} }
    //
    // For triggering an a href
    // { label: {String}, url: {String} }
    //
    // current: {String}
    // padding: {int} Left padding

    this.state = {
      displayHamburgerMenu: false,
      isOpenHamburgerMenu: false,
    };
    this.popup_ids = [];
    this.hamburgerMenuRef = React.createRef();

    BannerMenu.instance = this;
  }

  sanitizeButtons = buttons => {
    const tt = [...buttons];
    return tt.map(button => {
      if (button.popup) {
        delete button.popup;
      }
      return button;
    })
  };

  logOut = () => {
    // Handle Logout
    const cookies = new Cookies();
    cookies.remove('token', { path: '/' });
    cookies.remove('access', { path: '/' });
    cookies.remove('refresh', { path: '/' });
    cookies.remove('user_wlf_id', { path: '/' });

    this.props.history.push('/login/');
    this.props.logout();
    this.props.clearOnboardingData();
    this.props.tdaClear();

    const origin = config_to_url(this.props.app.config);
    broadcast_message({
      source: WINDOW_EVENTS.CA_APP_LOGOUT,
    }, origin);
  };

  componentDidUpdate = (prevProps) => {
    const button_cmp = this.props.button_cmp;

    if (button_cmp
      && !button_cmp(this.props.buttons, prevProps.buttons)) {
      this.setButtonState();
    }
  }

  setButtonState = () => {
    this.popup_ids = [];

    const new_state = {
      mouse_over_id: "",
    };

    if (this.props.buttons) {
      // Set the show/hide state for each popup menu
      this.props.buttons.forEach(button => {
        if (button.popup) {
          this.popup_ids.push(button.id);
          new_state[button.id] = false;
        } else if (button.options) {
          this.popup_ids.push(button.id);
          new_state[button.id] = false;
          new_state[button.id + "_value"] = button.value;
        }
      });
    }

    if (this.props.right_button && this.props.right_button.popup) {
      this.popup_ids.push(this.props.right_button.id);
      new_state[this.props.right_button.id] = false;
    }

    this.setState(Object.assign({}, new_state));
  }

  componentDidMount = () => {
    window.addEventListener('click', this.handleClickOutside);
    this.setButtonState();
  }

  componentWillUnmount = () => {
    window.removeEventListener('click', this.handleClickOutside);
  }

  closeHamburgerMenu = event => {
      event.stopPropagation();
      this.setState({
          isOpenHamburgerMenu: false,
      })
  }

  handleClickOutside = (event) => {
    if (!this.hamburgerMenuRef.current || !this.hamburgerMenuRef.current.contains) {
      return;
    }

    const isOutsideHamburgerMenu = !this.hamburgerMenuRef.current.contains(event.target);
    if(this.hamburgerMenuRef && isOutsideHamburgerMenu && this.state.isOpenHamburgerMenu) {
      this.closeHamburgerMenu(event);
    }
  }

  dumpBlanks = (num, prefix) => {
    if (!num) {
      return null;
    }

    const result = [];
    for(let i=0; i < num; i++) {
      result.push( (
        <div className="column" key={sprintf("%s-%d", prefix, i)}>
        </div>
      ));
    }
    return result;
  };

  onClick = id => (event) => {
    if (this.props.onClick) {
      this.props.onClick(id);
    }
    this.closeHamburgerMenu(event)
  };

  onButtonMouseOver = (button_id, mouse_over) => () => {
    if (isMobile) {
      return;
    }

    setTimeout(() => {
      if (mouse_over) {
        this.setState({ mouse_over_id: button_id});
      } else if (this.state.mouse_over_id === button_id) {
        this.setState({ mouse_over_id: ""});
      }
    }, POPUP_TIMEOUT_MS);

  };

  toggleButtonMouseOver = (button_id) => () => {
    if (this.state.mouse_over_id === button_id) {
      this.setState({ mouse_over_id: "" });
    } else {
      this.setState({ mouse_over_id: button_id });
    }
  }

  renderButtons = () => {

    const result = [];
    const style = {
      display: "inline-block",
      padding: "0",
      color: this.props.bannerTextColor,
      cursor: "pointer",
    };
    const span_style = {
      margin: "0.8rem 0.5rem",
      padding: "0.2rem 0.5rem",
      display: "inline-block",
      fontSize: FONT_SIZE,
    }

    if (!this.props.buttons) {
      return [
        (
          <div
            className="column"
            key="one-div"
            style={style}>
            <span
              style={{...span_style, color: this.props.bannerColor}}>
              { ' ' }
            </span>
          </div>
        )
      ];
    }

    this.props.buttons.forEach((button, index) => {

      if (this.props.current === button.id) {
        style.textDecoration = "underline";
      }
      if (button.url) {
        // Navigate to external url
        result.push((
          <div
            className="column"
            style={style}
            onMouseOver={this.onButtonMouseOver(button.id, true)}
            onMouseOut={this.onButtonMouseOver(button.id, false)}
            key={sprintf("button-%d", index)}>
            <a href={button.url} target="_blank" rel="noopener noreferrer" style={{color: "inherit"}}>
              <span style={span_style}>{button.label}</span>
            </a>
          </div>
        ))

      } else if (button.options) {

        const button_style = {
          padding: "0.2rem 0.5rem",
          fontSize: "1rem",
          ...button.button_style,
        }
        const popup_client = {
          color: {
            background: this.props.client.color.banner_background,
            text: this.props.client.color.banner_text,
            mode: "dark",
          }
        }
        const option_popup = (
          <OptionPopupMenu
            style={button_style}
            menu_id={button.id}
            client={popup_client}
            buttons={button.options}/>);

        let label = "";
        if (button.label) {
          label = button.label;
        } else {
          const selected_popup = button.value;
          const selected_button = button.options.find(option => option.id === selected_popup);
          label = selected_button ? selected_button.label : button.options[0].label;
        }
        const span_local = {
          ...span_style,
        };
        if (button.border) {
          span_local.border = "1.5px solid white";
          span_local.borderRadius = "0.5rem";
        }
        result.push((
          <div
            className="column"
            style={style}
            onMouseEnter={this.onButtonMouseOver(button.id, true)}
            onMouseLeave={this.onButtonMouseOver(button.id, false)}
            key={button.id}>
            <span style={span_local}>{label}</span>
            { this.maybeGeneratePopup(button, option_popup) }
          </div>
        ));

      } else if (button.id) {
        // Trigger callback
        result.push( (
          <div
            className="column"
            style={style}
            key={sprintf("button-%d", index)}
            onMouseEnter={this.onButtonMouseOver(button.id, true)}
            onMouseLeave={this.onButtonMouseOver(button.id, false)}
            onClick={this.onClick(button.id)} >
            <span style={span_style}>{ button.label }</span>
            { this.maybeGeneratePopup(button, button.popup) }
          </div>
        ))
      } else if (button.label && !button.id) {

        // Just a label
        result.push( (
          <div
            className="column"
            style={style}
            key={sprintf("button-%d", index)}>
            <span style={{ ...span_style, ...button.style}}>{button.label}</span>
          </div>
        ))
      }

    });

    return result;
  };

  onButtonClick = button_id => ev => {
    const value = this.state[button_id];
    this.setState({[button_id]: !value});
  }

  onPopupMouseOver = (id, mouse_over) => ev => {
    setTimeout(() => {
      const prop = "popup_" + id;
      this.setState({
        mouse_over_id: "",
        [prop]: mouse_over
      });
    }, POPUP_TIMEOUT_MS);
  };

  maybeGeneratePopup = (button, popup_elem) => {
    const show_popup = (button.popup || button.options) && (
      this.state.mouse_over_id === button.id
      || this.state["popup_" + button.id]);

    return show_popup
      ? (
        <Popup
          style={button.popup_style}
          popup_id={button.id}
          onMouseOver={this.onPopupMouseOver}>
          { popup_elem }
        </Popup>
      ) : null;
  };

  dumpRightButton = (additionalStyle={}) => {
    const right_button = this.props.right_button;
    const style = {
      display: "flex",
      alignItems: "center",
      color: this.props.bannerTextColor,
      position: "absolute",
      right: this.props.style && this.props.style.paddingRight,
      cursor: "pointer",
      fontSize: FONT_SIZE,
      fontWeight: "600",
      ...additionalStyle,
    };
    const span_style = {
      display: "inline-block",
    };

    return (
      <div
        style={style}
        key="RightButton">
        { this.props.right_inner_elem }
        <div
          onMouseEnter={this.onButtonMouseOver(right_button.id, true)}
          onMouseLeave={this.onButtonMouseOver(right_button.id, false)}
          onClick={this.props.isMobile ? this.onClick(right_button.id) : this.onButtonClick(right_button.id)}>
          <span style={span_style}>{ right_button.label }</span>
          { this.maybeGeneratePopup(right_button, right_button.popup) }
        </div>
      </div>
    )
  };

  togglePopup = id => {
    const new_state = !this.state[id];
    this.setState({[id]: new_state});
  };

  renderNestedHamburgerButtons = (currentIndex) => {
      const {bannerTextColor, nestedButtons, nestedButtonOnClick, buttonIndexToNestUnder} = this.props;
      if(currentIndex !== buttonIndexToNestUnder || !nestedButtons) { return; }

      const li_style = {
          display: "flex",
          alignItems: "center",
          color: bannerTextColor,
          padding: "1rem 1rem 1rem 2.5rem",
          borderBottom: "1px solid #595959"
      }
      const result = nestedButtons.filter((button) => { 
          return button.id !== null;
       }).map((button, index) => {
        return (
            <li
                style={li_style}
                key={sprintf("nestedButton-%d", index)}
                onMouseEnter={this.onButtonMouseOver(button.id, true)}
                onMouseLeave={this.onButtonMouseOver(button.id, false)}
                onClick={() => nestedButtonOnClick(button.id)}>
                {button.label}
                {this.maybeGeneratePopup(button, button.popup)}
            </li>
        )
      })
      
      return result;
  }

  renderHamburgerButtons = () => {
    
    const {buttons, bannerTextColor, nestedButtons, fromUser, isLoggedIn, onBoarding} = this.props;
    const li_style = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color: bannerTextColor,
      padding: "1rem",
      borderBottom: "1px solid #595959"
    };

    const noNestedButtonsFromUser = !nestedButtons && fromUser;
    let result = [];

    if (buttons && !noNestedButtonsFromUser) {
        result = buttons.filter((button) => { 
            return button.url !== null || button.id !== null;
         }).map((button, index) => {
            if(button.url) {
                return (
                    <li
                    style={li_style}
                    key={sprintf("button-%d", index)}
                    onMouseOver={this.onButtonMouseOver(button.id, true)}
                    onMouseOut={this.onButtonMouseOver(button.id, false)}
                    onClick={() => this.onClick(button.id)}>
                        <a href={button.url} target="_blank" rel="noopener noreferrer" style={{color: "inherit"}}>
                            {button.label}
                        </a>
                    </li>
                )
            } else {
                return (
                    <React.Fragment key={sprintf("button-%d", index)}>
                        <li 
                        style={li_style}   
                        onMouseEnter={this.onButtonMouseOver(button.id, true)}
                        onMouseLeave={this.onButtonMouseOver(button.id, false)}
                        onClick={this.onClick(button.id)}>
                            { button.label }
                            { this.maybeGeneratePopup(button, button.popup) }   
                        </li>
                        {this.renderNestedHamburgerButtons(index)}
                    </React.Fragment>
                );
            }
        });
    }

    const logout_style = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color: bannerTextColor,
      padding: "1rem",
      borderTop: "1px solid #595959",
      marginTop: "auto"
    }

    if(isLoggedIn || onBoarding) {
        result.push(
            <li
            key={sprintf("logout-%d", result.length - 1)} 
            style={logout_style}
            onClick={this.logOut}>
                Log Out
            </li>
        )
    }
    
    return result;
  }

  toggleHamburgerMenu = event => {
    event.stopPropagation();
    this.setState( prevState => ({
      isOpenHamburgerMenu: !prevState.isOpenHamburgerMenu,
    }));
  }

  renderSmallBanner = () => {

    const hamburgerMenuContainerStyle = {
      background: `rgb(51, 51, 51)`
    }

    const hamburgerContainerStyle = {
      display: "flex",
      justifyContent: "flex-end",
      borderBottom: "1px solid #595959"
    }

    return (
      <div className={classNames("hamburger-menu-position-responsive open")}>
        <ul
          ref={this.hamburgerMenuRef}
          className="hamburger-menu-container-responsive"
          style={hamburgerMenuContainerStyle}>
          <HamburgerIcon
            toggleHamburgerMenu={this.toggleHamburgerMenu}
            hamburgerContainerStyle={hamburgerContainerStyle} />
          {this.renderHamburgerButtons()}
        </ul>
      </div>
    )
  }

  renderMenu = (style, do_right_button) => {

    const hamburgerMenuStyle = {
      display: !this.props.wlfFilter && this.props.app.width <= DEVICE_WIDTH.large ? "" : "none"
    };

    const bannerMenuStyle = {
      display: this.props.wlfFilter || !(this.props.app.width <= DEVICE_WIDTH.large) ? "flex" : "none",
      justifyContent: this.props.app.width <= DEVICE_WIDTH.large ? "center" : "",
      backgroundColor: `${this.props.bannerColor}`
    }

    const allAccountMenuStyle = {
      display: !this.props.wlfFilter && this.props.app.width <= DEVICE_WIDTH.large ? "flex" : "none",
      justifyContent: this.props.app.width <= DEVICE_WIDTH.large ? "center" : "",
      backgroundColor: `${this.props.bannerColor}`
    }

    const allAccountButtonStyle = {
      position: "relative !important"
    }

    const show_buttons = this.state.isOpenHamburgerMenu;

    return (
      <React.Fragment>
        <section style={hamburgerMenuStyle}>
          { show_buttons && this.renderSmallBanner() }
        </section>

        <section style={bannerMenuStyle}>
          <div className="columnsnn array-of-texts banner-menu-responsive" style={{...style}}>
            { this.dumpBlanks(this.props.preBlank, "pre") }
            { do_right_button && !this.props.fromUser && this.dumpRightButton() }
            { this.renderButtons() }
          </div>
        </section>

        <section style={allAccountMenuStyle}>
          <div className="columnsnn array-of-texts" style={{...style}}>
            {do_right_button && this.dumpRightButton(allAccountButtonStyle)}
          </div>
        </section>
      </React.Fragment>
    );

  }

  render = () => {
    const style = {
      backgroundColor: this.props.bannerColor,
      width: "100%",
      ...this.props.style,
    };

    if (this.props.padding) {
      style.paddingLeft = this.props.padding;
      style.paddingRight = this.props.padding;
    }
    const do_right_button = this.props.right_button;

    const provider_state = {};
    this.popup_ids.forEach(id => {
      provider_state[id] = this.state[id];
    });
    provider_state.toggle_popup = this.togglePopup;
    provider_state.onMouseOver = this.onPopupMouseOver;
    provider_state.onPopupMenuClick = (menu_id, button_id) => {
      this.setState({ [menu_id + "_value"]: button_id });
      this.props.onPopupMenuClick(menu_id, button_id);
    }

    return (
      <PopupContext.Provider value={provider_state}>
        {this.renderMenu(style, do_right_button)}
      </PopupContext.Provider>
    );
  }
}

export { BannerMenu };
